import axiosClient, { axiosClientV2 } from './axios.client.js';

export const listFormDesigns = async () => {
  try {
    const data = await axiosClient.get('forms/designs');
    return { forms: data?.forms ?? [], error: null };
  } catch (e) {
    return { forms: [], error: e?.message || e?.error || 'Failed to list forms' };
  }
};

export const getFormDesignById = async (id) => {
  try {
    const data = await axiosClient.get(`forms/design/${encodeURIComponent(id)}`);
    return { formDesign: data?.formDesign ?? null, error: null };
  } catch (e) {
    return { formDesign: null, error: e?.message || e?.error || 'Failed to load form' };
  }
};

export const createFormDesign = async (definition) => {
  try {
    const data = await axiosClient.post('forms/design', definition);
    return { formDesign: data?.formDesign ?? data ?? null, error: null };
  } catch (e) {
    return { formDesign: null, error: e?.message || e?.error || 'Failed to create form' };
  }
};

/**
 * POST /api/v1/forms/design/ai-chat
 * @param {{ messages: { role: string, content: string }[], model?: string, snapshot: object, formDesignId?: string, clientDiagnostics?: unknown }} body
 */
export const sendFormBuilderAiChat = async ({
  messages,
  model,
  snapshot,
  formDesignId,
  clientDiagnostics,
}) => {
  try {
    const payload = { messages, snapshot };
    if (model) payload.model = model;
    if (formDesignId) payload.formDesignId = formDesignId;
    if (clientDiagnostics != null) payload.clientDiagnostics = clientDiagnostics;
    const data = await axiosClient.post('forms/design/ai-chat', payload);
    return {
      reply: data?.reply ?? '',
      proposedSnapshot: data?.proposedSnapshot ?? null,
      proposedValidation: data?.proposedValidation ?? null,
      model: data?.model ?? null,
      error: null,
    };
  } catch (e) {
    return {
      reply: '',
      proposedSnapshot: null,
      proposedValidation: null,
      model: null,
      error: typeof e === 'string' ? e : (e?.message || e?.error || 'AI chat failed'),
    };
  }
};

/**
 * Same handler as v1 — POST /api/v2/forms/design/ai-chat (Studio parity + hydrateSessionUserForV2).
 */
export const sendFormBuilderAiChatV2 = async ({
  messages,
  model,
  snapshot,
  formDesignId,
  clientDiagnostics,
}) => {
  try {
    const payload = { messages, snapshot };
    if (model) payload.model = model;
    if (formDesignId) payload.formDesignId = formDesignId;
    if (clientDiagnostics != null) payload.clientDiagnostics = clientDiagnostics;
    const data = await axiosClientV2.post('forms/design/ai-chat', payload);
    return {
      reply: data?.reply ?? '',
      proposedSnapshot: data?.proposedSnapshot ?? null,
      proposedValidation: data?.proposedValidation ?? null,
      model: data?.model ?? null,
      error: null,
    };
  } catch (e) {
    return {
      reply: '',
      proposedSnapshot: null,
      proposedValidation: null,
      model: null,
      error: typeof e === 'string' ? e : (e?.message || e?.error || 'AI chat failed'),
    };
  }
};
